import React from "react";
import "./fonts/fonts.css";
import "./App.css";

import Reminders from "./components/Reminders";

const App = () => {
  return (
    <>
      <Reminders />
    </>
  );
};

export default App;
